import { CaseType } from "./enums/CaseType";

export class ListDataFilter {
  userId?: string;
  CaseId?: number;
  courseId?: number;
  CaseIdType?: CaseType;
}
